import { Flex } from '@acsbe/ui';
import {
  StripeModuleProvider,
  useBilling,
  useDomainSelection,
} from '../../../context';
import { CustomPaymentMethodForm } from './custom-stripe-form';
import { StripeWizard } from './StripeWizard/StripeWizard';

export function AddPaymentMethodForm() {
  const { currentAccessibeAccount } = useDomainSelection();
  const { billingAddress, billingsCount } = useBilling();

  const hasSingleBillingAddress = Boolean(
    currentAccessibeAccount?.singleBillingAddress,
  );

  const shouldCollectAddress =
    (billingsCount === 0 && currentAccessibeAccount?.stripeCustomerId) ||
    !hasSingleBillingAddress ||
    !billingAddress?.address;

  return (
    <Flex gap={8} self="stretch">
      <StripeModuleProvider>
        {shouldCollectAddress ? <StripeWizard /> : <CustomPaymentMethodForm />}
      </StripeModuleProvider>
    </Flex>
  );
}
